module.exports = __webpack_public_path__ + "img/menu-selected.7d23fac1.svg";